import React, { useEffect, useState } from "react";
import API from "../utils/axiosInstance";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { FaPlay, FaLock } from "react-icons/fa";
import "./Videos.css";

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await API.get("/videos");
        setVideos(res.data);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, []);

  const handleVideoClick = async (videoId, isLocked) => {
    if (isLocked) return;
    try {
      const res = await API.get(`/videos/${videoId}/link`);
      window.open(res.data.url, "_blank");
    } catch (error) {
      console.error("Error fetching video URL:", error);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <div className="sidebar-fixed">
        <Sidebar isOpen={isSidebarOpen} />
      </div>

      <div className="dashboard-main">
        <Navbar onToggleSidebar={() => setIsSidebarOpen(prev => !prev)} />

        <div className="video-content">
          <h4 className="section-title">Videos</h4>

          <div className="videos-grid">
            {videos.map((video) => (
              <div
                key={video.id}
                className={`video-card ${video.isLocked ? "locked" : ""}`}
                onClick={() => handleVideoClick(video.id, video.isLocked)}
              >
                <img
                  src="/images/videos/thumbnail.png"
                  alt="Video Thumbnail"
                  className="video-thumbnail"
                />
                <div className="video-overlay">
                  {video.isLocked ? (
                    <>
                      <FaLock className="lock-icon" />
                      <p className="locked-text">Upgrade to watch</p>
                    </>
                  ) : (
                    <>
                      <FaPlay className="play-icon" />
                      <p className="video-title">{video.title}</p>
                      <span className="video-duration">{video.duration}</span>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
